<template>
  <div class="get-in-touch-hero">
    <h1>READY TO EMPLOY AI?</h1>
    <p>Our flagship AI Accelerator Program is a 6-week sprint to embed AI into your operations.  We target one high-impact process and build an automation that works from day one.</p>
    <router-link to="/contact">
      <button type="submit" class="submit-btn">LET'S TALK</button>
    </router-link>
  </div>
</template>

<script setup>

</script>

<style scoped>
.get-in-touch-hero {
  width: 100%;
  height: 257px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: 
    linear-gradient(rgba(0, 32, 96, 0.6), rgba(0, 32, 96, 0.6)),
    url('@/assets/images/laptop-colour.jpg');
  background-size: cover;
  background-position: center;
}

.get-in-touch-hero h1 {
  width: 330px;
  font-size: 24px;
  margin-bottom: 5px;
  color: white;
  text-align: center;
  font-family: Oxanium-SemiBold;
}

.get-in-touch-hero p {
  width: 316px;
  font-size: 13px;
  line-height: 21px;
}

.submit-btn {
  width: 82px;
  height: 40px;
  margin-top: 10px;
  background-color: #00FF0C;
  color: #000;
  border: none;
  padding: 0.75rem 0;
  font-weight: bold;
  font-size: 11px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.submit-btn:hover {
  background-color: #00e600;
}


@media (min-width: 640px) {

}

/* md: ≥ 768px - Tablets / landscape phones */
@media (min-width: 768px) {

}

/* lg: ≥ 1024px - Small laptops */
@media (min-width: 1024px) {
  .get-in-touch-hero {
    height: 450px;
    margin-top: 85px;
  }

  .get-in-touch-hero h1 {
    width: 1161px;
    height: 80px;
    font-size: 50px;
    line-height: 70px;
  }

  .get-in-touch-hero p {
    width: 969px;
    font-size: 24px;
    line-height: 35px;
    margin-bottom: 50px;
  }

  .submit-btn {
    width: 201px;
    height: 66px;
    font-size: 22px;
  }
}

@media (min-width: 1280px) {
}

/* 2xl: ≥ 1536px - Large screens / 4K monitors */
@media (min-width: 1536px) {
  .hero {
    height: 550px;
    margin-top: 105px;
  }

  .hero h1 {
    width: 1361px;
    height: 176px;
    font-size: 70px;
    line-height: 90px;
  }

  .submit-btn {
    width: 201px;
    height: 66px;
    font-size: 24px;
  }
}


</style>